// extracted by mini-css-extract-plugin
export default {"studio":"StudioContainer-module_studio__UX9b_"};